import { Component, ViewChild, OnInit } from "@angular/core";
import { MatTableDataSource, MatSort } from "@angular/material";
import { MatPaginator } from "@angular/material/paginator";
import { SharedService } from "./service/shared.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  DarkMode: boolean;

  constructor(public sharedService: SharedService) {}

  ToggleDakMode() {
    var element = document.body;
    element.classList.toggle("dark-mode");
    this.DarkMode = !this.DarkMode;
    this.sharedService.darkmode = this.DarkMode;
  }
}
